import React from 'react';
import { socialCardKeys } from 'src/constants/socialcard.constant'
import parse from 'html-react-parser';
import dayjs from 'dayjs';

import { textColors, cardColors } from 'src/constants/wall.constant';

import ClassNames from 'src/components/componentHelper/ClassNames'

import ReadMoreReadLess from 'src/components/componentHelper/ReadMoreReadLess'

const GraphicVideoCard = ({ cardWidth, cardItem, fontStyle, darkModeEnabled, cardFontColor, cardBackgroundObject, darkCardTheme, linkColor, engagementDisabled, isDateTimeDisabled, smallSize, shortenText, refresh }) => {

    return (
        <div
         className="mx-auto" 
         style={{maxWidth: "40rem",minWidth:cardWidth }}>
      
      <div 
      className="graphic-main-encloser" 
      style={
         darkModeEnabled? 
           { ...(cardBackgroundObject?cardBackgroundObject:{}), border:'2px solid #fff'} :
           {...(cardBackgroundObject?cardBackgroundObject:{}),  border:'2px solid #000' }
       }
      >


  <div className={ClassNames("tweet-content ",fontStyle && fontStyle!==''?`font-${fontStyle}`:'')} style={{ color: !darkModeEnabled ? (cardFontColor || textColors.black.primary) : (cardFontColor || textColors.light.primary), fontSize: !smallSize?"1.15em":"1.0em",lineHeight: !smallSize? 1.5: 1.7 }}>
              {
               cardItem[socialCardKeys.messageContent] && cardItem[socialCardKeys.messageContent]!=='' &&
               <div className="content mb-3" dir="auto">
   {cardItem[socialCardKeys.messageContent] && cardItem[socialCardKeys.messageContent]!==''?
                  shortenText?
                        <ReadMoreReadLess elementId={cardItem[socialCardKeys.uuid]}  refresh={()=>refresh()} text={cardItem[socialCardKeys.messageContent]} parse={parse} length={300} readMore={"Read More"} readLess={"Read Less"}/>
                        :
                        parse(cardItem[socialCardKeys.messageContent])
                  :
                  null
               }
                              </div>
               }
               {
                  cardItem[socialCardKeys.screenshotImage] &&
                  <div className="flex justify-center w-full">

                     <img className="w-auto h-auto rounded-md " onLoad={()=>refresh()} loading='lazy' style={{ width: '100%', borderRadius:'8px', objectFit: 'contain' }} src={cardItem[socialCardKeys.screenshotImage]} alt="Post Preview" />

                  </div>
               }
  </div>

  
  
                  <div className={fontStyle && fontStyle!==''?`font-${fontStyle}`:''} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.secondary), fontSize: 13 } : { color: (cardFontColor || textColors.light.secondary), fontSize: 13 }}>
                  <span>{(!isDateTimeDisabled && cardItem[socialCardKeys.messageTime])?dayjs(cardItem[socialCardKeys.messageTime]).locale('en').format('DD MMM YYYY'):null}</span>
               </div>

</div>

    


</div>
    );
};

export default GraphicVideoCard;

